import React, { useState } from 'react';
import $ from 'jquery';
import './poapprovaltracker.css';

const PoapprovaltrackerComponent = () => {
  const [cardTitle] = useState('Approval Tracker');
  const [objporeq, setObjporeq] = useState(null);
  const [boolPoreqList, setBoolPoreqList] = useState(false);
  
  const [porequirementdetail] = useState([
    {
      requirementdate: '2021-03-05',
      department: 'ADMIN',
      purpose: 'Water Bottles',
      purchasecategory: 'Use and Through',
      approxvalue: 1000.0,
      description: 'Water Bootle Purchase',
      receivedbenefit: 'Water Bottles To Employees',
      info: [
        {
          materialname: 'Water Bottle',
          description: 'Water Bottle',
          quantity: 100,
          approxunitvalue: 10.0,
          approxtotalvalue: 1000.0,
        },
      ],
    },
    {
      requirementdate: '2021-03-06',
      department: 'ADMIN',
      purpose: 'Water Bottles and Towels',
      purchasecategory: 'Use and Through',
      approxvalue: 2000.0,
      description: 'Water Bootle and Towels Purchase',
      receivedbenefit: 'Water Bottles and Towels To Employees',
      info: [
        {
          materialname: 'Water Bottle',
          description: 'Water Bottle',
          quantity: 100,
          approxunitvalue: 10.0,
          approxtotalvalue: 1000.0,
        },
        {
          materialname: 'Towels',
          description: 'Towels',
          quantity: 100,
          approxunitvalue: 10.0,
          approxtotalvalue: 1000.0,
        },
      ],
    },
    {
      requirementdate: '2021-03-04',
      department: 'ADMIN',
      purpose: 'Pen and Paper',
      purchasecategory: 'Stationery',
      approxvalue: 1000.0,
      description: 'Pen and Paper for Employees',
      receivedbenefit: 'Usage of Works and Printing',
      info: [
        {
          materialname: 'Pen',
          description: 'Pen',
          quantity: 50,
          approxunitvalue: 10.0,
          approxtotalvalue: 500.0,
        },
        {
          materialname: 'Papers',
          description: 'A4 Sheet for Printouts and works',
          quantity: 500,
          approxunitvalue: 1.0,
          approxtotalvalue: 500.0,
        },
      ],
    },
    {
      requirementdate: '2021-03-03',
      department: 'ADMIN',
      purpose: 'Mobile Phone',
      purchasecategory: 'Phone',
      approxvalue: 20000.0,
      description: 'Mobile Phone for Gift',
      receivedbenefit: 'Gift to the Chief guest',
      info: [
        {
          materialname: 'Mobile Phone',
          description: 'OnePlus Mobile Phone series 9',
          quantity: 1,
          approxunitvalue: 42999.0,
          approxtotalvalue: 42999.0,
        },
      ],
    },
    {
      requirementdate: '2021-03-02',
      department: 'ADMIN',
      purpose: 'Food',
      purchasecategory: 'Food',
      approxvalue: 25000.0,
      description: 'Food for Admin Staffs',
      receivedbenefit: 'Food for Admin Staffs',
      info: [
        {
          materialname: 'Food',
          description: 'Food for Admin Staffs',
          quantity: 1,
          approxunitvalue: 25000.0,
          approxtotalvalue: 25000.0,
        },
      ],
    },
  ]);
  const [porequirmentDetails, setPorequirmentDetails] = useState([]);
  const [comment, setComment] = useState('');
  const [quatation1, setQuatation1] = useState('AGS Group of company quatation value =542786');
  const [quatation2, setQuatation2] = useState('KCG Group of company quatation value =9989768');
  const [quatation3, setQuatation3] = useState('VSS Group of company quatation value =7665555');
  
  const ShowPorequirementdetail = (data) => {
    setObjporeq(data);
    setPorequirmentDetails(data.info);
    setBoolPoreqList(true);
  };

  const openModal = () => {
    $('#modal_approval').modal('show');
  };

  const approveorder = () => {
    $('#modal_approval').modal('hide');
  };

  const rejectorder = () => {
    $('#modal_approval').modal('hide');
  };

  const list = () => {
    setBoolPoreqList(false);
  };

  return (
    <div className="content-wrapper">
      <section className="content">
        <div className="container-fluid">
          <div className="block-header">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item bcrumb-1">
                    <a href="../../Dashboard">
                      <i className="fa fa-home"></i> Home
                    </a>
                  </li>
                  <li className="breadcrumb-item active">PO Approval</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="cord">
                <form>
                  <div>
                    <h4 className="header d-flex justify-content-between">
                      {cardTitle}
                      <div hidden={!boolPoreqList} onClick={list}>
                        Back
                      </div>
                    </h4>
                    <div className="body">
                      <div hidden={boolPoreqList}>
                        <table className="display table table-hover table-checkable order-column m-t-20 width-per-100" id="tableExport">
                          <thead>
                            <tr className="bg-light-gray2">
                              <th id="fontsize">Requirement Date</th>
                              <th id="fontsize">Department</th>
                              <th id="fontsize">Purpose</th>
                              <th id="fontsize">PurchaseCategory</th>
                              <th id="fontsize" style={{ textAlign: 'center' }}>
                                View
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {porequirementdetail.map((porequirement) => (
                              <tr key={porequirement.requirementdate}>
                                <td>{porequirement.requirementdate}</td>
                                <td>{porequirement.department}</td>
                                <td>{porequirement.purpose}</td>
                                <td>{porequirement.purchasecategory}</td>
                                <td style={{ textAlign: 'center' }} onClick={() => ShowPorequirementdetail(porequirement)}>
                                  <i className=" fa fa-eye font-medium-3 mr-2 text-info"></i>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      <div hidden={!boolPoreqList}>
                        <div className="row">
                          <div className="form-group col-md-4 mb-2">
                            <table>
                              <tr className="pad-14">
                                <th className="pad-14">
                                  <label htmlFor="userinput2">Requirement Date</label>
                                </th>
                                <th className="pad-14">{objporeq && objporeq.requirementdate}</th>
                              </tr>
                              <tr>
                                <th className="pad-14">
                                  <label htmlFor="userinput2">Purchase Category</label>
                                </th>
                                <th className="pad-14">{objporeq && objporeq.purchasecategory}</th>
                              </tr>
                              <tr>
                                <th className="pad-14">
                                  <label htmlFor="userinput2">Description</label>
                                </th>
                                <th className="pad-14">{objporeq && objporeq.description}</th>
                              </tr>
                            </table>
                          </div>
                          <div className="form-group col-md-4 mb-2">
                            <table>
                              <tr>
                                <th className="pad-14">
                                  <label htmlFor="userinput2">Department</label>
                                </th>
                                <th className="pad-14">{objporeq && objporeq.department}</th>
                              </tr>
                              <tr>
                                <th className="pad-14">
                                  <label htmlFor="userinput2">Type of Purchase</label>
                                </th>
                                <th className="pad-14">{objporeq && objporeq.typeofpurchase}</th>
                              </tr>
                              <tr>
                                <th className="pad-14">
                                  <label htmlFor="userinput2">Received Benefits</label>
                                </th>
                                <th className="pad-14">{objporeq && objporeq.receivedbenefit}</th>
                              </tr>
                            </table>
                          </div>
                          <div className="form-group col-md-4 mb-2">
                            <table>
                              <tr>
                                <th className="pad-14">
                                  <label htmlFor="userinput2">Purpose</label>
                                </th>
                                <th className="pad-14">{objporeq && objporeq.purpose}</th>
                              </tr>
                              <tr>
                                <th className="pad-14">
                                  <label htmlFor="userinput2">Approximate Value</label>
                                </th>
                                <th className="pad-14">{objporeq && objporeq.approxvalue}</th>
                              </tr>
                            </table>
                          </div>
                        </div>
                        <div className="row pad-14">
                          <table className="table table-striped table-bordered">
                            <thead>
                              <tr className="bg-light-gray2">
                                <th className="th-sm">Material/Service Name</th>
                                <th className="th-sm">Description</th>
                                <th className="th-sm">Quantity</th>
                                <th className="th-sm">Approx Unit Value</th>
                                <th className="th-sm">Approx Total Value</th>
                              </tr>
                            </thead>
                            <tbody>
                              {porequirmentDetails.map((cost, index) => (
                                <tr key={index}>
                                  <td>{cost.materialname}</td>
                                  <td>{cost.description}</td>
                                  <td>{cost.quantity}</td>
                                  <td>{cost.approxunitvalue}</td>
                                  <td>{cost.approxtotalvalue}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        <a data-toggle="collapse" data-parent="#accordionEx" href="#collapsePorequirementtabInfo" aria-expanded="true" aria-controls="collapsePorequirementtabInfo">
                          <h5 className="form-section mt-3 text-primary mb-2 p-2 bg-light">
                            <i className="ft-info"></i> Quatation
                          </h5>
                        </a>
                        <div id="collapsePorequirementtabInfo" className="collapse position-relative" role="tabpanel">
                          <div className="row">
                            <div className="form-group col-md-4 mb-2">
                              <label htmlFor="userinput1">Quatation 1</label>
                              <textarea className="form-control bg-transparent" value={quatation1} onChange={(e) => setQuatation1(e.target.value)} name="quatation1" id="quatation1" tabIndex="7" maxLength="500"></textarea>
                            </div>
                            <div className="form-group col-md-4 mb-2">
                              <label htmlFor="userinput1">Quatation 2</label>
                              <textarea className="form-control bg-transparent" value={quatation2} onChange={(e) => setQuatation2(e.target.value)} name="quatation2" id="quatation2" tabIndex="7" maxLength="500"></textarea>
                            </div>
                            <div className="form-group col-md-4 mb-2">
                              <label htmlFor="userinput1">Quatation 3</label>
                              <textarea className="form-control bg-transparent" value={quatation3} onChange={(e) => setQuatation3(e.target.value)} name="quatation3" id="quatation3" tabIndex="7" maxLength="500"></textarea>
                            </div>
                          </div>
                        </div>

                        <div className="row pad-14">
                          <div className="col-3">
                            <button type="submit" className="btn btn-raised btn-info btn-min-width mr-1" onClick={openModal}>
                              Forward to Dept Head
                            </button>
                          </div>
                          <div className="col-3">
                            <button type="submit" className="btn btn-raised btn-danger btn-min-width mr-1" onClick={openModal}>
                              Reject
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PoapprovaltrackerComponent;



// import React, { useState, useEffect, useRef } from 'react';
// // import { useHistory } from 'react-router-dom';

// // import { HttpClient } from '../common/httpClient';

// import $ from 'jquery';
// import axios from 'axios';
// import { getUploadedFileNativePath } from '../../services/common/credentials';
// import { AgGridReact } from 'ag-grid-react';
// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';
// import { Select } from 'semantic-ui-react';

// const P2PTrackerComponent = () => {
//   // const history = useHistory();
//   const [userdtl, setUserdtl] = useState();
//   const [user, setUser] = useState();
//   const [cardTitle, setCardTitle] = useState("Po Approval Tracker");
//   const [objporeq, setObjporeq] = useState();
//   const [boolPoreqList, setBoolPoreqList] = useState(false);
  
//   const [rowData, setrowData] = useState(null);

//   const [porequirementdetail] = useState([
//         {
//           requirementdate: '2021-03-05',
//           department: 'ADMIN',
//           purpose: 'Water Bottles',
//           purchasecategory: 'Use and Through',
//           approxvalue: 1000.0,
//           description: 'Water Bootle Purchase',
//           receivedbenefit: 'Water Bottles To Employees',
//           info: [
//             {
//               materialname: 'Water Bottle',
//               description: 'Water Bottle',
//               quantity: 100,
//               approxunitvalue: 10.0,
//               approxtotalvalue: 1000.0,
//             },
//           ],
//         },
//         {
//           requirementdate: '2021-03-06',
//           department: 'ADMIN',
//           purpose: 'Water Bottles and Towels',
//           purchasecategory: 'Use and Through',
//           approxvalue: 2000.0,
//           description: 'Water Bootle and Towels Purchase',
//           receivedbenefit: 'Water Bottles and Towels To Employees',
//           info: [
//             {
//               materialname: 'Water Bottle',
//               description: 'Water Bottle',
//               quantity: 100,
//               approxunitvalue: 10.0,
//               approxtotalvalue: 1000.0,
//             },
//             {
//               materialname: 'Towels',
//               description: 'Towels',
//               quantity: 100,
//               approxunitvalue: 10.0,
//               approxtotalvalue: 1000.0,
//             },
//           ],
//         },
//         {
//           requirementdate: '2021-03-04',
//           department: 'ADMIN',
//           purpose: 'Pen and Paper',
//           purchasecategory: 'Stationery',
//           approxvalue: 1000.0,
//           description: 'Pen and Paper for Employees',
//           receivedbenefit: 'Usage of Works and Printing',
//           info: [
//             {
//               materialname: 'Pen',
//               description: 'Pen',
//               quantity: 50,
//               approxunitvalue: 10.0,
//               approxtotalvalue: 500.0,
//             },
//             {
//               materialname: 'Papers',
//               description: 'A4 Sheet for Printouts and works',
//               quantity: 500,
//               approxunitvalue: 1.0,
//               approxtotalvalue: 500.0,
//             },
//           ],
//         },
//         {
//           requirementdate: '2021-03-03',
//           department: 'ADMIN',
//           purpose: 'Mobile Phone',
//           purchasecategory: 'Phone',
//           approxvalue: 20000.0,
//           description: 'Mobile Phone for Gift',
//           receivedbenefit: 'Gift to the Chief guest',
//           info: [
//             {
//               materialname: 'Mobile Phone',
//               description: 'OnePlus Mobile Phone series 9',
//               quantity: 1,
//               approxunitvalue: 42999.0,
//               approxtotalvalue: 42999.0,
//             },
//           ],
//         },
//         {
//           requirementdate: '2021-03-02',
//           department: 'ADMIN',
//           purpose: 'Food',
//           purchasecategory: 'Food',
//           approxvalue: 25000.0,
//           description: 'Food for Admin Staffs',
//           receivedbenefit: 'Food for Admin Staffs',
//           info: [
//             {
//               materialname: 'Food',
//               description: 'Food for Admin Staffs',
//               quantity: 1,
//               approxunitvalue: 25000.0,
//               approxtotalvalue: 25000.0,
//             },
//           ],
//         },
//       ]);
 

// //   const Unapproved = () => {
// //     setrowData(unapprovedlist);
// //     setListval('Unapproved List');
// //   };

// //   const approved = () => {
// //     setrowData(approvedlist);
// //     setListval('approved List');
// //   };

// //   const revertClick = () => {
// //     // Implement the functionality for the revert button here
// //     console.log('Revert button clicked!');
// //   };

// //   const approveorder = (action) => {
// //     // Implement the functionality for the approve, hold, and reject buttons here
// //     console.log('Action:', action);
// //   };

// //   const fileInput = useRef(null);

// //   const handleClose = () => {
// //     setshow(false);
// //   }

// //   const handleSubmit = () => {
// //     setshow(false);
// //   }

// //   const displayTable = () => {
// //     setshow1(false);
// //   }
//   const displayModel = () => {
//     setshow(true);
//     setBoolPoreqList(true);
//   }

//   useEffect(() => {
//     setUserdtl(JSON.parse(localStorage.getItem('useracess')));
//     setUser(JSON.parse(localStorage.getItem('Userdtl')));
//     setComment("");

//   }, []);




//   var gridColumns = [

//     { field: 'requirementdate', headerName: 'requirementdate', sortable: true, filter: true, resizable: true },
//     { field: 'department', headerName: 'department', sortable: true, filter: true, resizable: true },
//     { field: 'purpose', headerName: 'purpose', sortable: true, filter: true, resizable: true },
//     { field: 'purchasecategory', headerName: 'purchasecategory', sortable: true, filter: true, resizable: true },
    
//     {
//       headerName: 'View',
//       cellRendererFramework: (params) => (
//         <button
//           onClick={() => ShowPorequirementdetail(params)}
//           className="edit-button"
//         >
//           <i className="fa fa-view" aria-hidden="true"></i>
//         </button>
//       ),
//       width: 80,
//     },

//   ]


//         // Rest of the code...

//         return (
//         <>
//           <div className="content-wrapper">
//             <section className="content">
//               <div className="container-fluid">
//                 <div className="block-header">
//                   <div className="row">
//                     <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
//                       <ul className="breadcrumb">
//                         <li className="breadcrumb-item bcrumb-1">
//                           <a href="../../Dashboard">
//                             <i className="fa fa-home"></i> Home
//                           </a>
//                         </li>
//                         <li className="breadcrumb-item active">PO Approval</li>
//                       </ul>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="row">
//                   <div className="col-md-12">
//                     <div className="card1">
//                       <form>
//                         <div>
//                           <h4 className="header d-flex justify-content-between">
//                             {cardTitle}
//                             <div hidden={!boolPoreqList} onClick={list}>
//                               Back <i className="fa fa-hand-o-right"></i>
//                             </div>
//                           </h4>



//                           <div hidden={!boolPoreqList}>
//                             <div className="row">

//                               <div className="form-group col-md-4 mb-2">
//                                 <table>
//                                   <tr className="pad-14">
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">PRF No</label>
//                                     </th>
//                                     <th>{objporeq?.prf_number}</th>
//                                   </tr>
//                                   <tr>
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">Requirement Date</label>
//                                     </th>
//                                     <th> {objporeq?.requirement_date}</th>
//                                   </tr>
//                                   <tr>
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">Department</label>
//                                     </th>
//                                     <th> {objporeq?.department}</th>
//                                   </tr>
//                                 </table>
//                               </div>
//                               <div className="form-group col-md-4 mb-2">
//                                 <table>
//                                   <tr className="pad-14">
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">Reporting Manager</label>
//                                     </th>
//                                     <th> {objporeq?.reporting_manager}</th>
//                                   </tr>
//                                   <tr>
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">Purpose</label>
//                                     </th>
//                                     <th> {objporeq?.purpose}</th>
//                                   </tr>
//                                   <tr>
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">Purchase Category</label>
//                                     </th>
//                                     <th> {objporeq?.purchase_catagory}</th>
//                                   </tr>
//                                 </table>
//                               </div>
//                               <div className="form-group col-md-4 mb-2">
//                                 <table>
//                                   <tr className="pad-14">
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">Type of Purchase</label>
//                                     </th>
//                                     <th> {objporeq?.purchase_catagory}</th>
//                                   </tr>
//                                   <tr>
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">Location</label>
//                                     </th>
//                                     <th> {objporeq?.location}</th>
//                                   </tr>
//                                   <tr>
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">Budgeted</label>
//                                     </th>
//                                     <th> {objporeq?.is_budgeted}</th>
//                                   </tr>
//                                 </table>
//                               </div>
//                               <div className="form-group col-md-4 mb-2">
//                                 <table>
//                                   <tr className="pad-14">
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">Date of Delivery Expected</label>
//                                     </th>
//                                     <th> {objporeq?.date_of_delivery_expected}</th>
//                                   </tr>
//                                   <tr>
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">Delivery Address</label>
//                                     </th>
//                                     <th> {objporeq?.delivery_address}</th>
//                                   </tr>
//                                   <tr>
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">Requirement Total</label>
//                                     </th>
//                                     <th> {objporeq?.budget_allocated}</th>
//                                   </tr>
//                                 </table>
//                               </div>
//                               <div className="form-group col-md-4 mb-2">
//                                 <table>
//                                   <tr className="pad-14">
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">PaymentTerm</label>
//                                     </th>
//                                     <th>{objporeq?.payment_term} </th>
//                                   </tr>
//                                   <tr className="pad-14">
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">perceived Benefits</label>
//                                     </th>
//                                     <th>{objporeq?.perceived_benefits} </th>
//                                   </tr>
//                                   <tr>
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">Finalized Vendor</label>
//                                     </th>
//                                     <th>{objporeq?.finalized_vendor} </th>

//                                   </tr>
//                                 </table>
//                               </div>
//                               <div className="form-group col-md-4 mb-2">
//                                 <table>
//                                   <tr>
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">Approver Email ID</label>
//                                     </th>
//                                     <th> {objporeq?.approver_mailid}</th>
//                                   </tr>

//                                   <tr>
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">Approver name</label>
//                                     </th>
//                                     <th> {objporeq?.approver_name}</th>
//                                   </tr>
//                                   <tr>
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">Approver Department</label>
//                                     </th>
//                                     <th> {objporeq?.approver_department}</th>
//                                   </tr>
//                                 </table>
//                               </div>
//                               <div className="form-group col-md-4 mb-2">
//                                 <table>
//                                   <tr>
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">PO Doc</label>
//                                     </th>
//                                     <th>
//                                       <a className="text-primary cursor-pointer" target="_blank" href="http://65.1.209.204:10002/static/PO07688_Team_Computers_Pvt_Ltd__Delhi_2021_07_13_14_46_41_447511.pdf">
//                                         {objporeq?.po_file_name}
//                                       </a>
//                                     </th>
//                                   </tr>

//                                   <tr>
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">Supporting Doc</label>
//                                     </th>
//                                     <th>
//                                       <a className="text-primary cursor-pointer" target="_blank" href="http://65.1.209.204:10002/static/">
//                                         {objporeq?.SupportFile_name}
//                                       </a>
//                                     </th>
//                                   </tr>
//                                   <tr>
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">Vendor Doc</label>
//                                     </th>
//                                     <th>
//                                       <a className="text-primary cursor-pointer" target="_blank" href="http://65.1.209.204:10002/static/">
//                                         {objporeq?.VendorFile_name}
//                                       </a>
//                                     </th>
//                                   </tr>
//                                 </table>


//                               </div>
//                               <div className="form-group col-md-4 mb-2">
//                                 <table>
//                                   <tr>
//                                     <th className="pad-14">
//                                       <label htmlFor="userinput2">PO Number</label>
//                                     </th>
//                                     <th> {objporeq?.po_number}</th>
//                                   </tr>
//                                   <tr>
//                                     <th className="pad-14">

//                                       <a onClick={displayModel}><i className="fa fa-check-square-o"></i> Quotations</a>

//                                     </th>
//                                   </tr>
//                                 </table>
//                               </div>

//                             </div>

//                             <div className="row pad-14">

//                               {/* {porequirmentDetails?.map((poqutation) => ( */}
//                               <table className="table table-striped table-bordered" >
//                                 <thead>
//                                   <tr className="bg-light-gray2">
//                                     <th className="th-sm"> Material/Service Name </th>
//                                     <th className="th-sm"> Description </th>
//                                     <th className="th-sm"> Budget Category </th>
//                                     <th className="th-sm"> Quantity </th>
//                                     <th className="th-sm"> Approx Unit Value </th>
//                                     <th className="th-sm"> Approx Total Value </th>
//                                   </tr>
//                                 </thead>
//                                 <tbody>
//                                   {porequirmentDetails?.map((quotationItem) => (
//                                     <tr key={quotationItem.pobudgetinfo_id}>
//                                       <td>{quotationItem.material_name}</td>
//                                       <td>{quotationItem.line_description}</td>
//                                       <td>{quotationItem.budget_category}</td>
//                                       <td>{quotationItem.quantity}</td>
//                                       <td>{quotationItem.unit_value}</td>
//                                       <td>{quotationItem.total_value}</td>
//                                     </tr>
//                                   ))}
//                                 </tbody>
//                               </table>
//                               {/* ))} */}


//                             </div>

//                             </div>
//                         </div>
//                       </form>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </section>



//             <div className="report" hidden={boolPoreqList}>
              
//               <div className="ag-theme-balham report-layer" style={{ width: '100%', heidght: '100%' }}>
//                 <AgGridReact
//                   columnDefs={gridColumns}
//                   rowData={porequirementdetail}
//                   paginationPageSize={paginationsize}
//                   pagination={true}
//                   animateRows={true}
//                   rowSelection={'multiple'}
//                   groupSelectsChildren={true}

//                   suppressAggAtRootLevel={true}
//                   suppressRowClickSelection={true}

//                 >
//                 </AgGridReact>
//               </div>
//             </div>

            
//           </div>
//         </>
//         );

// };

//  export default P2PTrackerComponent;